import {GET_NBA_VIDEO_LIST_START, GET_NBA_VIDEO_LIST, HANDLE_VIDEO_LIST_ERROR} from '../constants';
import {processCustomPrograms} from '../../utils';

const initialState = {};

const processShowData = (seasonsData) => {
	const ret = {};
	const seasons = [];
	const episodes = {};
	let currentSeason;
	for (let i = 0; i < seasonsData.length; i += 1) {
		currentSeason = seasonsData[i].season ? seasonsData[i].season : (i + 1).toString();
		seasons[seasons.length] = currentSeason;
		episodes[currentSeason] = seasonsData[i].episodes
				? processCustomPrograms(seasonsData[i].episodes) : [];
	}
	ret.seasons = seasons;
	ret.episodes = episodes;
	return ret;
};

const processVideoListProgramsData = (state, action) => {
	let ret = {};
	if (action.isShow) {
		ret = {
			...state[`${action.curation}/${action.slug}`],
			[action.pageNumber]: {
				data: action.results.seasons ? processShowData(action.results.seasons) : [],
			},
			collection: action.results.series,
			hasNextPage: false,
			isShow: true,
		};
	} else {
		ret = {
			...state[`${action.curation}/${action.slug}`],
			[action.pageNumber]: {
				...state[`${action.curation}/${action.slug}`][action.pageNumber],
				data: action.results.videos ? processCustomPrograms(action.results.videos) : [],
				isLoading: false,
			},
			collection: action.results.collection,
			pageSize: action.results.count,
			totalPages: action.results.pages,
			totalCount: action.results.total,
			hasNextPage: action.results.pageNext && action.results.pageNext !== false,
			isShow: false,
		};
	}
	return ret;
};

const videolist = (state = initialState, action) => {
	switch (action.type) {
		case GET_NBA_VIDEO_LIST_START:
			return {
				...state,
				[`${action.curation}/${action.slug}`]: {
					...state[`${action.curation}/${action.slug}`],
					[action.pageNumber]: {
						data: null,
						isLoading: true,
					},
				},
			};
		case GET_NBA_VIDEO_LIST:
			return {
				...state,
				[`${action.curation}/${action.slug}`]: processVideoListProgramsData(state, action),
			};
		case HANDLE_VIDEO_LIST_ERROR:
			return {
				...state,
				[`${action.curation}/${action.slug}`]: {
					[action.pageNumber]: {
						errorCode: action.errorCode,
						data: null,
						isLoading: false,
					},
				},
			};
		default:
			return state;
	}
};

export default videolist;
